import {
  ModifyAlarmGroupUpdatePayload,
  UnifiedMonitoringProduct,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useModifyAlarmGroupUpdates(
  alarmGroupId: string,
  updateId: string,
  product: UnifiedMonitoringProduct,
  payload: ModifyAlarmGroupUpdatePayload,
  onSuccess?: () => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/location_alarms/${alarmGroupId}/updates/${updateId}?product=${product}`;
  const request = new Request(url, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });

  return useAuthenticatedMutation<null, ModifyAlarmGroupUpdatePayload>(
    request,
    {
      onSuccessInvalidationKeys: [['location_alarm_updates', alarmGroupId]],
      onSuccess,
      onError,
    }
  );
}

export default useModifyAlarmGroupUpdates;
